import { useTheme } from "@mui/material";

interface IconStyleProps {
  isPrimary?: boolean;
  isSetByCustomer?: boolean;
}

// Hook för ikonstilar
export const useIconStyles = ({
  isPrimary,
  isSetByCustomer,
}: IconStyleProps) => {
  const theme = useTheme();

  return {
    marginLeft: 2,
    marginRight: 2,
    color:
      isSetByCustomer && isPrimary
        ? theme.palette.primary.main
        : isPrimary
        ? "inherit"
        : "lightgray",
  };
};
